// extracted by mini-css-extract-plugin
module.exports = {"Links":"Links_Links__CLMSe","Links_icon":"Links_Links_icon__blE5y"};